import { get, groupBy } from 'lodash'
import { createSelector } from 'reselect'
import { AJ_EVENT_CATEGORIES } from 'constants/enums'

export const createGroupActivities = () =>
  createSelector(
    activities => activities,
    activities =>
      groupBy(activities, item => get(item, 'activitySection.value'))
  )

export const selectAJ = createSelector(
  aJValues => aJValues,
  (_, categoryId) => categoryId,
  (_, __, id) => id,
  (aJValues, categoryId, id) => {
    const findSingle = categoryType => {
      const journeys = get(
        aJValues,
        'data.adventurousJourneys',
        []
      ).filter(aj => {
        return aj.ajEventCategoryType === categoryType
      })

      const currJourney =
        journeys && journeys.find(journey => journey.id === Number(id))

      return currJourney || get(journeys, '[0]')
    }

    if (categoryId === AJ_EVENT_CATEGORIES.practice.url) {
      return findSingle(AJ_EVENT_CATEGORIES.practice.id)
    } else if (categoryId === AJ_EVENT_CATEGORIES.qualification.url) {
      return findSingle(AJ_EVENT_CATEGORIES.qualification.id)
    }

    const categoryKey = Object.keys(AJ_EVENT_CATEGORIES).find(
      key => get(AJ_EVENT_CATEGORIES[key], 'url') === categoryId
    )

    return get(aJValues, 'data.adventurousJourneys', []).find(
      aj => aj.ajEventCategoryType === AJ_EVENT_CATEGORIES[categoryKey].id
    )
  }
)

export const transformJourneys = createSelector(
  journeys => journeys,
  journeys => {
    if (!Array.isArray(journeys)) {
      return {
        ...journeys,
        title: get(journeys, 'ajEvent.ajEventCategory.translationText'),
        url: get(
          AJ_EVENT_CATEGORIES,
          `ids['${journeys.ajEventCategoryType}'].url`
        )
      }
    }

    const enhanced = journeys.map(journey => {
      return {
        ...journey,
        title: get(journey, 'ajEvent.ajEventCategory.translationText'),
        url: get(
          AJ_EVENT_CATEGORIES,
          `ids['${journey.ajEventCategoryType}'].url`
        )
      }
    })

    return enhanced
  }
)
